import { Link } from "react-router";
import { useT } from "../i18n/LocaleProvider.js";
import { useDocumentTitle } from "../lib/useDocumentTitle.js";

export function NotFoundPage() {
  const { m, lp } = useT();
  useDocumentTitle(m.meta.pages.notFound);
  return (
    <div className="container container--narrow section">
      <h1>{m.common.notFoundHeading}</h1>
      <p className="muted">{m.common.notFoundBody}</p>
      <Link className="btn btn--primary" to={lp("/")}>
        {m.common.home}
      </Link>
    </div>
  );
}
